/*
 * Free Tray Table guard
 * - Each $0 'free-tray-table' line carries hidden properties set on the product page:
 *     _promo_parent   = variant id of the promo lounge it came with
 *     _trays_per_unit = free tray tables earned per one lounge
 * - Allowed free trays for a parent = (qty of that lounge variant in cart) x _trays_per_unit.
 * - Free tray lines with no parent, a parent no longer in the cart, or more than allowed
 *   are reduced/removed automatically, then the page reloads so the cart UI is correct.
 * - Direct visits to /products/free-tray-table are redirected to the paid Tray Table.
 */
(function () {
  if (window.__freeTrayGuard) return;
  window.__freeTrayGuard = true;

  var FREE_HANDLE = 'free-tray-table';
  var PAID_URL = '/products/tray-table';

  if (/\/products\/free-tray-table\/?$/.test(window.location.pathname)) {
    window.location.replace(PAID_URL);
    return;
  }

  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var timer = null;

  function check() {
    if (running) return;
    running = true;

    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lounges = {};
        cart.items.forEach(function (it) {
          if (it.handle === FREE_HANDLE) return;
          lounges[String(it.variant_id)] = (lounges[String(it.variant_id)] || 0) + it.quantity;
        });

        var used = {};
        var updates = {};
        var changed = false;

        cart.items.forEach(function (it) {
          if (it.handle !== FREE_HANDLE) return;
          var props = it.properties || {};
          var parent = props._promo_parent ? String(props._promo_parent) : '';
          var perUnit = parseInt(props._trays_per_unit, 10) || 0;
          var allowed = parent && lounges[parent] ? lounges[parent] * perUnit : 0;
          var alreadyUsed = used[parent] || 0;
          var newQty = Math.max(0, Math.min(it.quantity, allowed - alreadyUsed));
          used[parent] = alreadyUsed + newQty;
          if (newQty !== it.quantity) {
            updates[it.key] = newQty;
            changed = true;
          }
        });

        if (!changed) return null;

        return nativeFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          window.location.reload();
        });
      })
      .catch(function (e) { console.warn('Free tray guard:', e); })
      .then(function () { running = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 400);
  }

  // Re-check after any AJAX cart change made by the theme (drawer, cart page, quick add).
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(schedule, schedule);
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
